<template>
    <el-container class="approval-instance-select-list">
        <el-main class="choose-enterprise-body">
            <el-container>
                <el-aside style="width: 60%;height: 500px;">
                    <div class="tools-bar">
                        <span><el-tag type="success">已完成的审批流人员列表</el-tag></span>
                        <div class="tools-search" @keyup.enter="handleSearch">
                            <el-input maxlength="100" v-model.trim="searchParams.approvalName" placeholder="审批流名称">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                            </el-input>
                        </div>
                    </div>
                    <el-table :data="selectItemList" highlight-current-row @current-change="handleSelectionChange" style="width: 100%;" v-loading="selectLoading" stripe>
                        <el-table-column
                            label="审批名称"
                            prop="approvalName"
                            :show-overflow-tooltip="true"
                            align="center"
                            width="230">
                        </el-table-column>
                        <el-table-column
                            label="审批流人员"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                    <el-step v-for="(item, index) in scope.row.users" :class="activeClass(item)" :key="index" :title="item.trueName" ></el-step>
                                </el-steps>
                                <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                    <el-step v-for="(item, index) in scope.row.approVoList" :class="activeClass(item)" :key="index" align-center >
                                        <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                            <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                        </el-breadcrumb>
                                    </el-step>
                                </el-steps>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-row type="flex" justify="end">
                        <el-pagination
                            background
                            layout="total,sizes, prev, pager, next"
                            :total="page.totalPageNum"
                            :current-page="page.currentPage"
                            :page-size="page.pageSize"
                            :page-sizes="[6, 10, 20, 50, 100, 300]"
                            @current-change="queryFormDataByPage"
                            @size-change="queryFormDataByPageSize"
                            >
                        </el-pagination>
                    </el-row>
                </el-aside>
                <el-aside style="width: 40%;height: 500px;">
                    <div class="tools-bar">
                        <span><el-tag type="success">已选择的审批流人员</el-tag></span>
                    </div>
                    <el-table :data="selectedItemList" tooltip-effect="dark" style="width: 100%;" stripe>
                        <el-table-column
                            label="审批流人员"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                    <el-step v-for="(item, index) in scope.row.users" :class="activeClass(item)" :key="index" :title="item.trueName"></el-step>
                                </el-steps>
                                <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                    <el-step v-for="(item, index) in scope.row.approVoList" :class="activeClass(item)" :key="index" align-center >
                                        <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                            <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                        </el-breadcrumb>
                                    </el-step>
                                </el-steps>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-aside>
            </el-container>
            <div class="choose-enterprise-btn">
                <el-button type="info" @click="cancelClick">取消</el-button> 
                <el-button type="primary" @click="confirmClick">确定</el-button> 
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import { getApprovalInstanceList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        components: {
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                selectedApprovalInstance: {
                    selectedUserIds: '',
                    selectedUserNames: '',
                    approvalList: [],
                    approvalUserGroupList: []
                },
                searchParams: {
                    approvalTemplateId: '',
                    approvalName: '',
                    producer: '',
                    serviceType: '',
                    state: null,
                    isOther: false,
                    isCopyFlag: 0,
                    approvalStatus: 12 // 已完成的审批
                },
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 5, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                selectItemList: [], // 待选择的列表数据
                selectLoading: false, // 授权加载状态
                selectedItemList: [] // 已选择的列表数据
            };
        },
        created () {
            this._initPage();
        },
        props: {
            approvalTemplateId: {
                type: String
            },
            approvalStatus: {
                type: Number,
                default: 12
            }
        },
        methods: {
            async _initPage () {
                // console.log('approvalTemplateId=====' + this.approvalTemplateId);
                this.searchParams.approvalTemplateId = this.approvalTemplateId;
                this.searchParams.approvalStatus = this.approvalStatus;
                this._getFormData();
            },
            async _getFormData () {
                this.selectLoading = true;
                let formData = await getApprovalInstanceList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, this.searchParams));
                if (formData) {
                    this.selectItemList = formData.data;
                    this.page = {
                        currentPage: formData.currentPage,
                        pageSize: formData.pageSize,
                        totalPageNum: formData.totalPageNum
                    };
                }
                this.selectLoading = false;
            },
            handleSearch () {
                this._getFormData();
            },
            handleSelectionChange (row) {
                if (row) {
                    this.selectedItemList = [];
                    this.selectedItemList.push(row);
                }
                // 按顺序重新赋值
                this.selectedApprovalInstance = row;
            },
            queryFormDataByPage (currentPage) {
                this.page.currentPage = currentPage;
                this._getFormData();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this._getFormData();
            },
            activeClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-step';
                } else if (item.stepStatus === 2) {
                    return 'reject-step';
                } else if (item.stepStatus === 99) {
                    return 'now-step';
                } else {
                    return '';
                }
            },
            activeUserClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-user';
                } else if (item.stepStatus === 2) {
                    return 'reject-user';
                } else if (item.stepStatus === 99) {
                    return 'now-user';
                } else {
                    return '';
                }
            },
            cancelClick () {
                this.$emit('cancel');
            },
            confirmClick () {
                this.$emit('confirm', this.selectedApprovalInstance);
            }
        }
    };
</script>

<style lang="less">
    .approval-instance-select-list {
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }
        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
        .success-step{
          .el-step__head{
              color: #67c23a;
              border-color: #67c23a;
              .is-success{
                color: #67c23a;
                border-color: #67c23a;
              }
          }
          .el-breadcrumb__inner{
                color: #c0c4cc;
                .is-success{
                    color: #67c23a;
                    border-color: #67c23a;
                }
           }
           .success-user .el-breadcrumb__inner{
               color: #67c23a;
           }
          .el-step__title{
              color: #67c23a;
          }
          .el-step__description{
              color: #303133;
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #67c23a;
            color: #67c23a;
          }
        }
        .reject-step{
          .el-step__head{
              color: #f56c6c;
              border-color: #f56c6c;
          }
           .el-breadcrumb__inner{
                color: #c0c4cc;
           }
           .reject-user .el-breadcrumb__inner{
               color: #f56c6c;
           }
          .el-step__title{
              color: #f56c6c;
          }
          .el-step__description{
              color: #303133;
          }
          // .el-step__line {
          //   position: absolute;
          //   border-color: inherit;
          //   background-color: #f56c6c;
          //   color: #f56c6c;
          // }
        }
        .now-step{
          .el-step__head {
              color: #409eff;
              border-color: #409eff;
              .is-success{
                color: #409eff;
                border-color: #409eff;
              }
          }
          .el-breadcrumb__inner{
                color: #409eff;
                border-color: #409eff;
                .is-success{
                    color: #409eff;
                    border-color: #409eff;
                }
            }
          .el-step__title{
              color: #409eff;
              .is-process{
                font-weight: 700;
              }
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #409eff;
            color: #409eff;
          }
        }
        .choose-enterprise-body{
            .companySelectPop {
                height: 365px;
                .el-header {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .el-main {
                    padding: 0;
                }
        
                .el-aside {
                    border-right: 1px solid #dcdfe6;
                }
            }
        }
        .choose-enterprise-btn{
            text-align: right;
            padding-right: 20px;
            position: relative;
            top: 20px;
            margin: 10px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ApprovalInstanceSelectPop/ApprovalInstanceSelectPop.vue